import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";


@Component({
    selector: 'app-dynamic-report-dialog',
    templateUrl: './dynamic-report.dialog.html'
})


export class DynamicReportDialog implements OnInit{
    constructor(
        public dialogRef: MatDialogRef<DynamicReportDialog>,
        private formBuilder: FormBuilder,
        private http: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    reportForm: FormGroup;
    searches = {};
    showResult = false;
    resultLink = '';
    isLoading = false;
    isSearching = {};
    ngOnInit() {
        this.reportForm = this.createForm();
    }

     createForm() {
        let formG: FormGroup = new FormGroup({});
        this.data.report.params.forEach(param => {
            formG.registerControl(param.controlName, new FormControl((param.type === 'switch' ? true : null), (param.required ? Validators.required : null)))
            if (param.type == 'search') {
                this.searches[param.controlName] = [];
                this.isSearching[param.controlName] = false;
            }
        });

        return formG;

    }

    logThis(option) {
        console.log(this.reportForm.getRawValue());
        console.log(option)
    }

    onSearch(control) {
        this.isSearching[control.controlName] = true;

        this.http.get(control.searchBy + this.reportForm.getRawValue()[control.controlName]).subscribe(data => {
            console.log(data, 'DEBUG');
            this.isSearching[control.controlName] = false;
            this.searches[control.controlName] = data;
        })
    }


    prepareQuery() {
        let val = this.reportForm.getRawValue();

        let query = '';
        this.data.report.params.forEach((value, index) => {
            if (val[value.controlName] != null) {
                if(index === 0) {
                    query += '?' + value.controlName + '=' + this.setDateOrString(val[value.controlName], value.type)
                }else {
                    query += '&' + value.controlName + '=' + this.setDateOrString(val[value.controlName], value.type)
                }
            }

        });

        return query
    }

    setDateOrString(value, type) {
        return type == 'date' ? value.toISOString() : value;
    }

    confirmDialog() {
        this.isLoading = true;
        let query = this.prepareQuery();
        this.http.get(this.data.report.url + query, {responseType: 'text'}).subscribe(data => {
            this.showResult = true;
            this.isLoading = false;
            console.log('result', data);
            this.resultLink = data;
            //this.dialogRef.close()
        }, err => {


            console.log(err)
        })
    }

    cancelDialog() {
        this.dialogRef.close()
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/dialogs/dynamic-report.dialog.ts